@import '../../../constants/spacing.module.less';

.rate-card-read-only-wrapper {
  display: flex;
  flex-direction: column;
  gap: @space-16;
}
